var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-settings-toggle"},[_c('div',{staticClass:"toggle-name"},[_vm._v(_vm._s(_vm.name))]),_c('button',{class:{ 'button-active': _vm.adminGetValue === true },attrs:{"disabled":_vm.socketSendLoading !== null},on:{"click":function($event){return _vm.adminSettingsToggle(!_vm.adminGetValue)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }